import React from 'react'
import { ConnectedNumberInput } from 'components/FormElements'
import ConnectedSelect from 'components/FormElements/ConnectedSelect'
import { SimpleGrid } from '@chakra-ui/react'
import {
  usePropertyAvailabilitiesQuery,
  usePropertyCategoriesQuery,
  useRentalTermsQuery,
  useTypeOfPropertiesQuery
} from 'generated/graphql'
import { useGeolocation } from 'hooks'
import { useTranslation } from 'react-i18next'

const PropertyInfo: React.FC<{
  isTabletOrMobile?: boolean
}> = ({ isTabletOrMobile }) => {
  const { i18n } = useTranslation()
  const tanslator = i18n as any
  const lang = tanslator.language as string
  const { data: propertyTypes } = useTypeOfPropertiesQuery({
    fetchPolicy: 'cache-first'
  })
  const { data: rentalTerms } = useRentalTermsQuery({
    fetchPolicy: 'cache-first'
  })
  const { data: propertyCategory } = usePropertyCategoriesQuery({
    fetchPolicy: 'cache-first'
  })
  const { data: propertyAvailability } = usePropertyAvailabilitiesQuery({
    fetchPolicy: 'cache-first'
  })
  const { currency } = useGeolocation()

  return (
    <>
      <ConnectedNumberInput
        name="Price"
        unit={currency?.currencySymbol}
        placeholder="e.g 800"
        label="Price *"
      />
      <ConnectedSelect
        name="Property_category"
        placeholder="Select a Property category"
        label="Property category *"
        options={
          propertyCategory?.propertyCategories?.map((propertyCategory) => ({
            label: propertyCategory?.name || '',
            value: propertyCategory?.id || ''
          })) || []
        }
      />
      <SimpleGrid rowGap={0} columnGap={2} columns={isTabletOrMobile ? 0 : 2}>
        <ConnectedSelect
          name="Lease_period"
          placeholder="Select a lease period"
          label="Lease Period *"
          options={[
            {
              label: '12 Months',
              value: '12 Months'
            },
            {
              label: '6 Months',
              value: '6 Months'
            }
          ]}
        />
        <ConnectedSelect
          name="Type_of_property"
          placeholder="Select a Type of property"
          label="Type of property  *"
          options={
            propertyTypes?.typeOfProperties?.map((propertyType: any) => ({
              label: propertyType?.[`name_${lang}`] || '',
              value: propertyType?.id || ''
            })) || []
          }
        />
        <ConnectedSelect
          name="Rental_term"
          placeholder="Select a Rental term"
          label="Rental term  *"
          options={
            rentalTerms?.rentalTerms?.map((rentalTerm: any) => ({
              label: rentalTerm?.[`name_${lang}`] || '' || '',
              value: rentalTerm?.id || ''
            })) || []
          }
        />
        <ConnectedSelect
          name="Property_availability"
          placeholder="Select a Property Availability"
          label="Property availability *"
          options={
            propertyAvailability?.propertyAvailabilities?.map((propertyAvailability: any) => ({
              label: propertyAvailability?.[`name_${lang}`] || '',
              value: propertyAvailability?.id || ''
            })) || []
          }
        />
      </SimpleGrid>
    </>
  )
}

export default PropertyInfo
